import { TextField } from '@warp-ds/react';
import { type ChangeEvent, useEffect, useMemo, useState } from 'react';
import { debounce } from 'shared/util/debounce';
import type { FilterProps } from '../../Filter';
import styles from './PriceFilter.module.css';

export const PriceFilter = ({ filters, onFilterChanged }: FilterProps) => {
    const maxPrice = 10000000;
    const [value, setValue] = useState<[number, number]>([0, maxPrice]);

    useEffect(() => {
        setValue([filters.price_from ?? 0, filters.price_to ?? maxPrice]);
    }, []);

    const onFilterChangedDebounced = useMemo(() => debounce(onFilterChanged, 1000), []); // useMemo to avoid creating a new debounced function on each render

    const onChange = (priceFrom: number, priceTo: number) => {
        setValue([priceFrom, priceTo]);
        onFilterChangedDebounced({ price_from: priceFrom, price_to: priceTo });
    };

    return (
        <div className="flex gap-16 full-width">
            <TextField
                helpText="Fra kr"
                type="number"
                value={value[0] === 0 ? '' : value[0].toString()} // hide default value from UI
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    const fromValue = Number(e.target.value) < 0 ? 0 : Number(e.target.value); // set to default 0 if negative number
                    onChange(fromValue, value[1]);
                }}
                onWheel={(e) => e.currentTarget.blur()}
                className={`flex-1 ${styles.input}`}
            />
            <TextField
                helpText="Til kr"
                type="number"
                value={value[1] === maxPrice ? '' : value[1].toString()} // hide default value from UI
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    const toValue = Number(e.target.value) < 0 ? maxPrice : Number(e.target.value); // set to default maxPrice if negative number
                    onChange(value[0], toValue);
                }}
                onWheel={(e) => e.currentTarget.blur()}
                className={`flex-1 ${styles.input}`}
            />
        </div>
    );
};
